import compact from 'lodash/compact'
import {
  PERMISSION_ACTION_DELETE,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ENTITY_OPERATIONAL,
  type PermissionAction
} from '@klear/constants'
import type { Money } from '@klear/money'
import { ORDER_EVENT_STATUS_DRAFT } from '@klear/constants/order-event-status'
import type { OrderEventStatusLabelsFor } from '@klear/order-event-lifecycle/lifecycle'

export const OPERATIONAL_STATUS_LABELS = {
  [ORDER_EVENT_STATUS_DRAFT]: 'Draft'
} as const satisfies OrderEventStatusLabelsFor<typeof PERMISSION_ENTITY_OPERATIONAL>

export const OPERATIONAL_ACTION_LABELS = {
  [PERMISSION_ACTION_VIEW]: 'View',
  [PERMISSION_ACTION_EDIT]: 'Edit',
  [PERMISSION_ACTION_DELETE]: 'Delete'
} as const satisfies Partial<Record<PermissionAction, string>>

export function operationalLineLabel(operational: { number?: string | null; title?: string | null }): string {
  const label = compact([operational.number ? `#${operational.number}` : null, operational.title]).join(' · ')
  return label.length > 0 ? label : 'Operational event'
}

export function operationalAmountLabel(amount: Money | null | undefined): string {
  return amount?.toString() ?? '—'
}
